export default async function () {
  document.documentElement.style.setProperty('--x', "50");
  document.documentElement.style.setProperty('--y', "50");

  const updateCursor = (event: PointerEvent) => {
    const { clientX: x, clientY: y } = event; // Extract clientX and clientY as x and y
    document.documentElement.style.setProperty('--x', x.toString());
    document.documentElement.style.setProperty('--y', y.toString());
  };

  const hero = document.querySelector('.hero'); // Selektor für den Hero-Bereich
  const iconconcontainer = document.querySelector('.fof_zone');
  
  if (hero) {
    hero.addEventListener('pointermove', updateCursor);
  }
  if (iconconcontainer) {
    iconconcontainer.addEventListener('pointermove', updateCursor);
  }
};
